// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2-wsx","modalForm":"UpgradeEpcsModal_modalForm__3L9QY","modalFooter":"UpgradeEpcsModal_modalFooter__vX2mx"};